import React, { useEffect, useState } from "react";
import { Table, Button, Spinner } from "react-bootstrap";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AllTickets = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resolving, setResolving] = useState("");
  const [error, setError] = useState("");

  const fetchTickets = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/tickets`);
      if (!res.ok) throw new Error("Failed to fetch tickets");
      const data = await res.json();
      setTickets(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  const handleResolve = async (id) => {
    setResolving(id);
    setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/ticket/${id}/resolve`, {
        method: "PATCH",
      });
      if (!res.ok) throw new Error("Failed to resolve ticket");
      // Update the ticket in the UI
      setTickets((prev) =>
        prev.map((ticket) =>
          ticket._id === id ? { ...ticket, resolved: true } : ticket
        )
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setResolving("");
    }
  };

  return (
    <div className="container mt-4">
      <h2>All Tickets</h2>
      {error && <div className="text-danger mb-2">{error}</div>}
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Title</th>
              <th>Description</th>
              <th>Created By</th>
              <th>Created At</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map((ticket) => (
              <tr key={ticket._id}>
                <td>{ticket.title}</td>
                <td>{ticket.description}</td>
                <td>{ticket.createdBy}</td>
                <td>{new Date(ticket.createdAt).toLocaleString()}</td>
                <td>{ticket.resolved ? "Resolved" : "Open"}</td>
                <td>
                  {ticket.resolved ? (
                    <span className="text-success">Resolved</span>
                  ) : (
                    <Button
                      variant="success"
                      size="sm"
                      disabled={resolving === ticket._id}
                      onClick={() => handleResolve(ticket._id)}
                    >
                      {resolving === ticket._id ? "Resolving..." : "Resolve"}
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default AllTickets;
